import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import * as React from 'react';
import styles from './style.module.scss';
import { Navbar, NavbarBrand, Container } from 'reactstrap';
import Logo from '../Logo';
import cn from 'classnames';
/**
 * The clean Header component
 * @param {React.Node}  children    The children
 * @param {Boolean}     center      Wether or not to center children
 **/

export var CleanHeader = function CleanHeader(_ref) {
  var children = _ref.children,
      _ref$center = _ref.center,
      center = _ref$center === void 0 ? false : _ref$center,
      _ref$fullWidth = _ref.fullWidth,
      fullWidth = _ref$fullWidth === void 0 ? false : _ref$fullWidth;
  return React.createElement("div", {
    className: styles.navWrapper
  }, React.createElement(Navbar, {
    className: styles.mainLayer,
    dark: true,
    expand: "md"
  }, React.createElement(Container, {
    fluid: fullWidth,
    className: cn(styles.mainLayer, _defineProperty({}, styles.center, center))
  }, children ? children : React.createElement(NavbarBrand, {
    title: "TruckJobs",
    className: styles.brand,
    href: "/"
  }, React.createElement(Logo, null)))));
};
export default React.memo(CleanHeader);